export class QBEntityDeleteRequest{
    public customerId!:number;
    public clientId!:number;
}